module.exports = __webpack_public_path__ + "static/media/Bank_Icon.e5ad3b89.svg";